import React, { useState } from 'react';
import { Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from './api';

function SifremiUnuttum() {
  const [eposta, setEposta] = useState('');
  const [mesaj, setMesaj] = useState('');
  const [hata, setHata] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMesaj('');
    setHata('');
    try {
      const res = await api.post('/sifre-sifirlama-talep', { eposta });
      setMesaj(res.data.mesaj);
    } catch (err) {
      setHata(err.response?.data?.mesaj || 'İşlem sırasında bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'relative', height: '100vh' }}>
      <div className="aurora-background" />
      <div className="d-flex align-items-center justify-content-center h-100" style={{ position: 'relative', zIndex: 1 }}>
        <Card className="glass-card text-white" style={{ width: '24rem' }}>
          <Card.Body>
            <h2 className="text-center mb-2">Şifremi Unuttum</h2>
            <p className="text-center mb-4" style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
              Kayıtlı e-posta adresinizi girin, size şifre sıfırlama bağlantısı gönderelim.
            </p>
            {mesaj ? (
              <>
                <Alert variant="success">{mesaj}</Alert>
                <div className="text-center">
                  <Link to="/giris" className="btn btn-outline-light btn-sm">Giriş sayfasına dön</Link>
                </div>
              </>
            ) : (
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>E-posta</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="ornek@mail.com"
                    value={eposta}
                    onChange={(e) => setEposta(e.target.value)}
                    required
                  />
                </Form.Group>
                <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                  {loading ? <Spinner size="sm" animation="border" /> : 'Sıfırlama Bağlantısı Gönder'}
                </Button>
                {hata && <Alert variant="danger" className="mt-3">{hata}</Alert>}
                <div className="text-center mt-3">
                  <Link to="/giris" style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>← Giriş sayfasına dön</Link>
                </div>
              </Form>
            )}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

export default SifremiUnuttum;
